import { DimSymbolsCommand } from "slotworks/commands/symbols/dim-symbols-command";
import { HighlightSymbolsCommand } from "slotworks/commands/symbols/highlight-symbols-command";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import Components from "slotworks/components/components";
import AbstractMediator from "slotworks/mediators/abstract-mediator";
import GameState from "slotworks/model/game-state";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import { unique } from "slotworks/utils/collection-utils";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import settingsModel from "slotworks/model/settings/settings-model";
import { DisplaySymbolsCommand } from "slotworks/commands/symbols/display-symbols-command";

export default class AllWinsMediator extends AbstractMediator {

    public start(): Contract<void> {
        if (GameState.currentGameHasSymbolWinResults()) {
            const currentRecord = GameState.getCurrentGame().getCurrentRecord();
            const allWins = currentRecord.results;
            let winningPositions: Point[] = [];

            const lowWinOnUk = settingsModel.isUKJurisdiction() && !GameState.getCurrentGame().isWinAboveBet();

            for (const win of allWins) {
                if (win instanceof SymbolWinResult) {
                    winningPositions = winningPositions.concat(win.positions);
                }
            }

            let winningSymbols = [];
            const winningSymbolIDs = [];

            for (const position of winningPositions) {
                const symbol = Components.matrix.getSymbol(position.x, position.y);
                winningSymbols.push(symbol);
                winningSymbolIDs.push(symbol.symbolId);
            }

            winningSymbols = unique(winningSymbols);
            const uniqueWinningSymbolIDs = unique(winningSymbolIDs);

            SoundManager.event(SoundEvent.highlight_all_wins);
            for (const symbolID of uniqueWinningSymbolIDs) {
                SoundManager.event(SoundEvent.symbol_ID_highlight, symbolID);
                let count = 0;
                for (const symbolToCount of winningSymbolIDs) {
                    if (symbolID === symbolToCount) {
                        count++;
                    }
                }
                SoundManager.event(SoundEvent.symbol_ID_MATCHES_highlight, symbolID, count.toString());
            }

            DimSymbolsCommand(Components.matrix.getAllSymbols()).execute();

            if(lowWinOnUk)
                return DisplaySymbolsCommand(winningSymbols)
            else
                return HighlightSymbolsCommand(winningSymbols);
        } else {
            return super.start();
        }
    }

    public end() {
        StaticSymbolsCommand().execute();
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/mediators/all-wins-mediator.ts